<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">订单列表</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 外层tab -->

    <!-- 列表tab  开始 -->

    <div class="tabboxlist">
      <van-tabs v-model="linekind" @click="clickchange">
        <van-tab v-for="(item,index) in linetab" :title="item.text"></van-tab>
      </van-tabs>
      <div class="page_tab" v-if="isoffline">
        <div class="page_tablist" v-for="(item,index) in navList1" @click="changelineIndex(index)">
          <div :class="index===navIndex1? 'page_tabname' : 'page_tabname1'">{{item}}</div>
        </div>
      </div>
      <div class="page_tab" v-else>
        <div class="page_tablist" v-for="(item,index) in navList" @click="changeNavIndex(index)">
          <div :class="index===navIndex? 'page_tabname' : 'page_tabname1'">{{item}}</div>
        </div>
      </div>
    </div>

    <!-- 列表tab  结束 -->
    <!--    <div class="top_all">
                  <img class="top_return" src="/static/xiangzuo.png" @click="toReturn()" />
                  <div class="top_tip" @click="showpopup()">
                    <div>订单列表</div>
                  </div>
                </div> -->
    <!--     <div class="search_order">
                  <input placeholder="请输入订单号" class="search_input" v-model="ordernum" />
                  <img src="/static/search.png" class="search_icon" />
                </div>  v-on:click.stop-->
    <div v-if="isoffline">
      <div class="orderList_detail" v-if="serList.length>0">
        <div v-for="(item,index) in serList">
          <div class="orderBox">
            <div class="orderbox_top">
              <div class="orderbox_top_time">{{item.created_at}}</div>
              <div class="orderbox_top_order_num">{{item.code}}</div>
            </div>
            <div class="product_center">
              <div class="product_centertop">
                <div class="product_thum">
                  <img class="product_thumimg" :src="item.product.thumb" />
                </div>
                <div class="product_descmesg">
                  <div class="productList_name">{{item.product_name}}</div>
                  <div class="productList_guige">
                    <div class="productList_guigedesc">店铺：{{item.store.name}}</div>
                    <div class="productList_paystatus">{{item.status_str}}</div>
                  </div>
                </div>
              </div>
              <div class="product_centerr_price">
                <div class="product_pricetitle" v-if="item.car_no">车牌号码：<span class="product_price" style="font-size: 12px">{{item.car_no}}</span></div>
                <div class="productList_pay">
                  <div class="productList_cancel" v-if="!item.comment_at && item.status==1" @click="toServeEvaluate(item.id)">去评价</div>
                </div>
                <!-- <div class="productList_cancel">查看订单</div> -->
              </div>
            </div>
          </div>
        </div>
        <div @click="getMore()" class='orderList_label more' v-if="datalengthX">查看更多</div>
      </div>
      <!-- 暂无信息  开始 -->
      <div class="page_none" v-else>
        <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
      </div>
      <!-- 暂无信息  结束 -->
    </div>
    <div v-else>
      <div class="orderList_detail" v-if="list.length>0">
        <div v-for="(item,index) in list" @click="toDetail(index)">
          <div class="orderBox" v-if="item.type=='mall' || item.type=='yl_shop'">
            <div class="orderbox_top">
              <div class="orderbox_top_time">{{item.created_at}}</div>
              <div class="orderbox_top_order_num">{{item.order_no}}</div>
            </div>
            <div class="product_center">
              <div class="product_centertop">
                <div class="product_thum">
                  <img class="product_thumimg" :src="item.product.thumb" />
                </div>
                <div class="product_descmesg">
                  <div class="productList_name">{{item.name}}</div>
                  <div class="productList_guige">
                    <div class="productList_guigedesc">规格：默认规格</div>
                    <div class="productList_paystatus">{{item.order_status_str}}</div>
                  </div>
                </div>
              </div>
              <div class="product_centerr_price">
                <div class="product_pricetitle">合计：<span class="product_price">￥{{item.amount}}</span></div>
                <!--  v-if="item.order_status==22 || item.order_status==30" -->
                <div class="productList_pay">
                  <div class="productList_cancel" v-if="item.order_status==22 || item.order_status==30" @click.stop="tologistics(item.order_no)">查看物流</div>
                  <div class="productList_payqueding" v-if="item.order_status==22" @click.stop="confirmReceive(item.id)">确认收货</div>
                </div>
                <!-- <div class="productList_cancel">查看订单</div> -->
              </div>
            </div>
          </div>
          <div class="orderBox" v-else>
            <div class="orderbox_top">
              <div class="orderbox_top_time">{{item.created_at}}</div>
              <div class="orderbox_top_order_num">{{item.order_no}}</div>
            </div>
            <div class="orderbox_center">
              <div class="orderbox_centertop">
                <div class="orderbox_center_c">
                  <img class="orderimg" src="/static/newprojecticon/youkachongzhi.png" />
                  <div class="orrder_detail">{{item.type=="second_order" ? item.name : item.product_name}}</div>
                </div>
                <div class="order_status">{{item.order_status_str}}</div>
              </div>
              <div class="orderbox_centerr_price">￥{{item.type=="second_order" ? item.paid_amount : item.product_price}}</div>
            </div>
          </div>
        </div>
        <div @click="getMore()" class='orderList_label more' v-if="datalengthX">查看更多</div>
      </div>

      <!-- 暂无信息  开始 -->
      <div class="page_none" v-else>
        <img src="/static/newprojecticon/zanwujilu.png" class="page_none_icon" />
      </div>
      <!-- 暂无信息  结束 -->
    </div>

    <!-- 弹出层  开始 -->
    <!--    <van-popup v-model="show" position="top" :style="{ height: '30%' }">
          <div v-for="(item,index) in orderKind" @click="changekind(index)">
            <div :class="item.kindchick ? 'orderkind1' : 'orderkind' ">{{item.kindname}}</div>
          </div>

        </van-popup> -->
    <!-- 弹出层  结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        ordernum: "",
        linekind: 0,
        linetab: [{
          text: "线上订单",
          value: 1
        }, {
          text: "线下订单",
          value: 2
        }],
        navList1: ["全部订单", "处理中", "已完成"],
        navList: ["全部订单", "待支付", "处理中", "已完成", "售后"],
        // orderKind: [{
        //   kindname: "油卡充值",
        //   kindchick: false
        // }, {
        //   kindname: "话费充值",
        //   kindchick: false
        // }, {
        //   kindname: "流量充值",
        //   kindchick: false
        // }, {
        //   kindname: "视频会员卡",
        //   kindchick: false
        // }, {
        //   kindname: "超市购物券",
        //   kindchick: false
        // }, {
        //   kindname: "美食券",
        //   kindchick: false
        // }, {
        //   kindname: "APP购物卡",
        //   kindchick: false
        // }, {
        //   kindname: "出行服务",
        //   kindchick: false
        // }, {
        //   kindname: "游戏卡密",
        //   kindchick: false
        // }, {
        //   kindname: "腾讯直充",
        //   kindchick: false
        // }, {
        //   kindname: "生活服务",
        //   kindchick: false
        // }],
        selectnav: false,
        show: false,
        kindisselect: false,
        list: [], // 接口获取列表
        serList: [], //线下订单列表
        // navList: ['全部', '待支付', '处理中', '已完成', '售后'], // nav:导航栏列表
        navIndex: 0, // nav:导航栏指针,默认为0
        navIndex1: 0, //线下订单指针
        datalengthX: false, //判断是否要继续请求订单列,默认值false
        pages: 1, //判断是否要继续请求订单的第几页数,默认值1
        page_size: 20, // 列表每页页数,默认为20
        isoffline: false
      }
    },
    created() {
      let that = this
      //上一页面传过来的参数
      if (that.$route.query.order_status) {
        that.navIndex = Number(that.$route.query.order_status)
      }
      // 读接口获取订单列表
      that.changeNavIndex(that.navIndex)
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      //线上|线下
      clickchange(event) {
        this.linekind = event
        if (this.linekind == 1) {
          this.isoffline = true
          this.changelineIndex(this.navIndex1)
        } else {
          this.isoffline = false
          this.changeNavIndex(this.navIndex)
        }
      },
      //返回上一页
      toReturn() {
        this.$router.go(-1)
      },
      //是否出现弹出层
      showpopup() {
        this.show = true
      },
      //改变选择不同种类订单
      changekind(e) {
        let that = this
        let orderKind = that.orderKind
        orderKind.map((item, index) => item.kindchick = index === Number(e))
        this.show = false
      },
      //去评价
      toServeEvaluate(id){
        console.log("id",id)
        let ids = id
        this.$router.push({
          path:"/serveEvaluate",
          query:{
            id:ids
          }
        })
      },
      //查看物流
      tologistics(orderno) {
        console.log("orderno", orderno)
        let order_no = orderno
        this.$router.push({
          path: '/logistics',
          query: {
            orderno: order_no,
          }
        })
      },
      //确认收货
      confirmReceive(orderid) {
        let that = this
        let order_id = orderid
        Dialog.confirm({
            title: '提示',
            message: '是否确认收货？',
          })
          .then(() => {
            that.request("confirmreceive", {
              order_id: order_id
            })
          })
          .catch(() => {
            return false;
          });

      },
      //改变不同状态订单
      // changenav(e) {
      //   let that = this
      //   let navList = that.navList
      //   navList.map((item, index) => item.selectone = index === Number(e))
      //   // tabHead.map((item,index) => item.isselect = index === Number(e))
      //   that.selectnav = that.navList[Number(e)].selectone
      // },
      //线下订单
      changelineIndex(index, page = 1, reset_list = true) {
        let that = this
        let requestData = {
          status: [],
          page: page,
          page_size: that.page_size,
        }
        this.navIndex1 = index
        this.pages = page
        if (reset_list) {
          this.serList = []
        }
        switch (that.navIndex1) {
          case 0:
            break
          case 1:
            requestData.status = [0]
            break
          case 2:
            requestData.status = [1]
            break
        }
        that.request('getOrderserList', requestData)
      },
      // 线上订单 点击切换导航栏指针
      changeNavIndex(index, page = 1, reset_list = true) {
        let that = this
        let requestData = {
          order_status: [],
          page: page,
          page_size: that.page_size,
        }
        this.navIndex = index
        this.pages = page
        if (reset_list) {
          this.list = []
        }
        switch (that.navIndex) {
          case 0:
            break
          case 1:
            requestData.order_status = [0]
            break
          case 2:
            requestData.order_status = [10]
            break
          case 3:
            requestData.order_status = [30]
            break
          case 4:
            requestData.order_status = [20, 40, 50]
            break
        }
        that.request('getOrderList', requestData)
      },
      //点击跳转到订单详情页面
      toDetail(index) {
        console.log("xiangqing")
        let order_no = this.list[index].order_no
        this.$router.push({
          name: 'orderListDetail',
          query: {
            id: order_no,
            navIndex: this.navIndex
          }
        })
      },
      //点击支付订单
      // toPay(orderId) {
      //     let that = this;
      //     if (!orderId) {
      //         this.$swal({
      //             title: '提示',
      //             text: '订单错误，请稍后重试',
      //             buttons: false,
      //             timer: 1000,
      //         })
      //         return;
      //     }
      //     //重新付款接口
      //     that.request('reUnifiedOrder', {
      //         order_id: orderId
      //     })
      // },
      //点击取消订单
      cancelOrder(index) {
        let that = this
        let orderId = that.list[index].id
        Dialog.confirm({
            title: '提示',
            message: '确认取消此订单吗',
          })
          .then(() => {
            let requestData = {
              order_id: orderId
            }
            that.request('cancelOrder', requestData)
          })
          .catch(() => {
            return false;
          });
      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取订单信息列表
          case 'getOrderList':
            httper.post('order/get-list', requestData, res => {
              let lengthX = res.data.length - 20 === 0 //判断列是否20条
              that.datalengthX = lengthX
              // that.list = [...this.list, ...res.data] //数据拼接,
              if (res.data.length > 0) {
                let list = that.list;
                for (let i = 0; i < res.data.length; i++) {
                  list.push(res.data[i]);
                }
                that.list = list
              }
            }, true)
            break
            //线下订单
          case 'getOrderserList':
            httper.post('order/ser-list', requestData, res => {
              let lengthX = res.data.length - 20 === 0 //判断列是否20条
              that.datalengthX = lengthX
              // that.list = [...this.list, ...res.data] //数据拼接,
              if (res.data.length > 0) {
                let list = that.serList;
                for (let i = 0; i < res.data.length; i++) {
                  list.push(res.data[i]);
                }
                that.serList = list
              }
            }, true)
            break
            // 取消订单信息
          case 'cancelOrder':
            httper.post('order/cancel', requestData, res => {
              if (res.code === 0) {
                that.$toast({
                  message: "取消成功"
                })
                setTimeout(function() {
                  that.changeNavIndex(that.navIndex)
                }, 1000)
              } else {
                that.$toast({
                  message: res.message || '系统异常'
                })
              }
            }, true)
            break
            // 确认收货
          case 'confirmreceive':
            httper.post('order/confirm-receive', requestData, res => {
              if (res.code === 0) {
                that.$toast({
                  message: "确认收货！"
                })
                // that.request("getOrderList",{
                //   order_status:[0]
                // })
                // setTimeout(function() {
                //   that.changeNavIndex(that.navIndex)
                // }, 1000)
                window.location.reload() //页面刷新

              } else {
                that.$toast({
                  message: res.message || '系统异常'
                })
              }
            }, true)
            break
        }
      },

      //查看更多
      getMore() {
        let that = this
        if(!that.datalengthX){
          that.$toast({
            message: '没有更多了'
          })
          return
        }
        let page = (that.pages) + 1
        if(this.isoffline){
          that.changelineIndex(that.navIndex1, page, false)
        }else{
          that.changeNavIndex(that.navIndex, page, false)
        }

      },
    }
  }
</script>

<style>
  .tabboxlist {
    background-color: #fff;
    position: fixed;
    top: 50px;
    width: 100%;
  }

  .order_tab {
    background-color: #fff;
    position: fixed;
    top: 50px;
  }

  /*  body {
      margin: 0;
      background-color: #FFFFFF;
    } */
  .orderList {
    margin: 0;
    background-color: #dedede;
  }

  input {
    border: none;
    outline: 0;
  }

  input::-webkit-input-placeholder {
    color: #dedee0;
  }

  .top_all {
    display: flex;
    border-bottom: 1px solid #B5B2B2;
    background-color: #FFFFFF;
    height: 40px;
  }

  .top_return {
    width: 20px;
    height: 20px;
    margin: 10px;
  }

  .top_tip {
    width: 81%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .order_xiala {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }

  .orderlist {
    background-color: #FFFFFF;
    /* padding: 10px; */
  }

  .search_order {
    display: flex;
    justify-content: center;
    margin: 10px;
  }

  .search_input {
    background-color: #efeef3;
    width: 300px;
    height: 15px;
    padding: 10px;
    border-radius: 10px;
    margin-right: 10px;
  }

  .search_icon {
    width: 30px;
    height: 30px;
  }

  .nav_list {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    /*    margin: 10px; */
  }

  .kind_text {
    color: #F0533E;
    padding-bottom: 10px;
    border-bottom: 1px solid #F0533E;
  }

  .kind_text1 {
    padding-bottom: 10px;
  }

  .none {
    width: 100%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    /*    margin-top: 100px; */
  }

  .noneorder_img {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }

  .none_order {
    font-size: 22px;
    color: #8a8a8a;
  }

  .orderkind {
    width: 110px;
    height: 30px;
    background-color: #eaeaea;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
  }

  .orderkind1 {
    width: 110px;
    height: 30px;
    background-color: #ff9940;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    color: #FFFFFF;
  }

  /*   .van-popup--top {
     width: 91%;
   }

   .van-popup {
     display: flex;
     flex-wrap: wrap;
     padding: 20px;
     box-sizing: border-box;
         justify-content: space-between;
    align-items: center;
  } */

  .van-tabs__line {
    background-color: #FD8C00;
    width: 23px !important;
  }

  .orderList_detail {
    /* margin: 20px; */
    /* margin-top: 55px;*/
    margin-top: 120px;
  }

  .orderBox {
    /*    box-shadow: 3px 3px 3px #dedede;
    background-color: #FFFFFF;
    margin-top: 10px; */
    width: 90%;
    /* padding: 20px; */
    min-height: 153px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 8px;
    margin: 10px 20px;
  }

  .orderbox_top {
    height: 38px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    align-items: center;
    border-bottom: 1px solid #dedede;
  }

  .orderbox_top_time {}

  .orderbox_top_status {}

  .orderbox_center {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    width: 95%;
    height: 90px;
  }

  .orderbox_centertop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }

  .orderbox_center_c {
    display: flex;
    align-items: center;
  }


  .orderimg {
    width: 30px;
    /* height: 23px; */
    margin-right: 10px;
  }

  .orrder_detail {
    font-size: 12px;
    font-weight: 400;
    color: rgba(54, 54, 54, 1);
  }

  .order_status {
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
  }

  .orderbox_centerr_price {
    width: 100%;
    height: 50px;
    margin-top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #FD8C00;
    text-align: end;
  }

  .orderList_label {
    margin: 20px 15px 0;
    display: block;
    text-align: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .more {
    padding: 10px 0;
    text-align: center;
    font-size: 15px;
    border: 1px solid #E3E3E3;
    box-shadow: 0 3px 3px #E3E3E3;
    color: orange;
    border-radius: 10px;
  }

  .product_center {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    min-height: 100px;
    margin-top: 10px;
  }

  .product_centertop {
    display: flex;
    align-items: center;
  }

  .product_thum {
    width: 20%;
    height: 58px;
    border-radius: 8px;
    margin-right: 10px;
  }

  .product_thumimg {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .product_descmesg {
    width: 80%;

  }

  .productList_name {
    font-size: 12px;
    margin-bottom: 10px;
  }

  .productList_guige {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .productList_guigedesc {
    font-size: 12px;
    color: #666666;
  }

  .productList_paystatus {
    font-size: 12px;
    color: #FD8C00;
  }

  .product_centerr_price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /*   margin-top: 15px; */
    padding: 15px 0;
  }

  .product_pricetitle {
    font-size: 12px;
  }

  .product_price {
    font-size: 12px;
    color: #FD8C00;
  }

  .productList_pay {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .productList_cancel {
    width: 58px;
    height: 19px;
    border: 1px solid rgba(125, 125, 125, 1);
    border-radius: 10px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }

  .productList_payqueding {
    width: 58px;
    height: 19px;
    border: 1px solid #FD8C00;
    border-radius: 10px;
    color: #FD8C00;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/orderList.vue